module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('p', {
    staticClass: "btn fp leading"
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_2--seq_2"
    }
  }, [_c('b', [_vm._v("Anne Herries,")]), _vm._v(" winner of the Romantic Novelists’ Association romance prize 2004, lives in Cambridgeshire. She is fond of watching wildlife, and spoils the birds and squirrels that are frequent visitors to her garden. Anne loves to write about the beauty of nature, and sometimes puts a little into her books—although they are mostly about love and romance. She writes for her own enjoyment, and to give pleasure to her readers. ")])]), _c('a', {
    attrs: {
      "id": "page_normal--num_2--seq_2"
    }
  }, [_c('p', {
    staticClass: "btn fp"
  }, [_c('b', [_vm._v("Recent novels by the same author:")])]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("A DAMNABLE ROGUE*"), _c('br'), _vm._v("MARIANNE AND THE MARQUIS†"), _c('br'), _vm._v("MARRIED BY CHRISTMAS†"), _c('br'), _vm._v("MARRYING CAPTAIN JACK†"), _c('br'), _vm._v("THE UNKNOWN HEIR"), _c('br'), _vm._v("THE HOMELESS HEIRESS ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("*"), _c('i', [_vm._v("Winner of the Romantic Novelists’ Association ")]), _c('i', [_vm._v("romance prize")]), _c('br'), _vm._v("†"), _c('i', [_vm._v("The Horne Sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_c('b', [_vm._v("And in the Regency series ")]), _c('i', [_c('b', [_vm._v("The Steepwood Scandal")])]), _c('b', [_vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "btn fp leading"
  }, [_vm._v("LORD RAVENSDEN’S MARRIAGE"), _c('br'), _vm._v("COUNTERFEIT EARL ")]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_c('b', [_vm._v("And in")]), _vm._v(" "), _c('i', [_c('b', [_vm._v("The Hellfire Mysteries")])]), _c('b', [_vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "btn fp"
  }, [_vm._v("AN IMPROPER COMPANION"), _c('br'), _vm._v("A WEALTHY WIDOW"), _c('br'), _vm._v("A WORTHY GENTLEMAN ")])])]), _c('a', {
    attrs: {
      "id": "page_normal--num_2--seq_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95e8b82c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781408901175_abouttheauthor.vue
// module id = 60
// module chunks = 0